import {
  TabsContainer,
  Icon,
  TabContent,
  getTranslatedText
} from '@nile/components';
import React from 'react';
import { InsightsContainer } from '@nile/projects/src/Containers';
import { Snowflake } from '@styled-icons/fa-solid';
import styled from 'styled-components';
import { injectIntl } from 'react-intl';

const InsightsIcon = styled(Snowflake)`
  height: 12px;
  width: 12px;
  color: black;
  margin-right: 8px;
`;

const ProjectInsightContainer = (props) => {
  const { intl } = props;
  const getTabContent = (t, suffix) => {
    switch (t) {
      case getTranslatedText(intl, 'project.details.insights'):
        return <TabContent content={t} icon={<InsightsIcon />} />;
      default:
        return t;
    }
  };

  const tabs = [
    {
      id: 'insights',
      content: getTabContent(
        getTranslatedText(intl, 'project.details.insights')
      ),
      accessibilityLabel: 'Insights',
      panelID: 'all-insights',
      component: <InsightsContainer {...props} />
    }
  ];

  // return <TabsContainer tabs={tabs} />;
  return <InsightsContainer {...props} />;
};

export default injectIntl(ProjectInsightContainer);
